var render = function (_h,_vm) {var _c=_vm._c;return _c('h1',{staticClass:"c-heading flex items-center",class:("c-heading__" + (_vm.props.variant))},[(_vm.$slots.pre)?_vm._t("pre"):_vm._e(),_vm._v(" "+_vm._s(_vm.props.text)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }